// extracted by mini-css-extract-plugin
export default {"wrapper":"Filter_wrapper__xwPJK","block":"Filter_block__vZr0m","block__cell":"Filter_block__cell__72G14"};